import React from 'react';
import { LOGO_URL } from '../constants';

// The dashboard's own "Loading your dashboard" card, drawn with inline styles
// so it renders before the dashboard's stylesheet (a lazy chunk) has loaded.
//
// Inside the Bubble phone app the sign-in and page-load steps show this
// instead of their own screens, so opening the dashboard is one steady
// loading card rather than "Signing you in" → "Loading…" → the dashboard.

const AppLoadingScreen: React.FC = React.memo(() => (
  <div
    style={{
      minHeight: '100vh',
      background: '#f6f6f1',
      display: 'grid',
      placeItems: 'center',
      padding: '40px 20px',
      fontFamily: "'Geist', -apple-system, system-ui, sans-serif",
      color: '#1b211e',
    }}
  >
    <div
      style={{
        width: '100%',
        maxWidth: 420,
        background: '#ffffff',
        border: '1px solid #e6e6dd',
        borderRadius: 20,
        padding: '40px 32px',
        boxShadow: '0 1px 3px rgba(20, 30, 25, 0.06), 0 4px 12px rgba(20, 30, 25, 0.04)',
        textAlign: 'center',
      }}
    >
      <img src={LOGO_URL} alt="SmartFilterPro" style={{ display: 'block', height: 56, width: 'auto', margin: '0 auto' }} />
      <h2 style={{ fontFamily: "'Fraunces', 'Source Serif 4', Georgia, serif", fontWeight: 400, fontSize: 26, letterSpacing: '-0.02em', margin: '18px 0 6px' }}>
        Loading your dashboard
      </h2>
      <p style={{ fontSize: 13, color: '#6c7268', margin: 0 }}>Pulling the latest readings from your devices…</p>
    </div>
  </div>
));

AppLoadingScreen.displayName = 'AppLoadingScreen';

export default AppLoadingScreen;
